import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch, onUnmounted  } from 'vue'
import { debounce } from 'lodash'
import { ElMessage } from 'element-plus'
import { AddRescueConfig } from '@/api/operation'
import SelectOperator from '@/components/SelectOperator.vue'
import useI18nTl from '@/hooks/useI18nTl'
import useProtocolEnums from '@/hooks/useProtocolEnums'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean
},
  emits: ['update:modelValue', 'success'],
  setup(__props, { emit }) {

const props = __props

const { rescueType, paymentModes, getPaymentModeDesc,GetRescueTypeDesc } = useProtocolEnums()

const { t } = useI18nTl('Base')





const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const formData = ref({
  rescueType: '',
  operatorId: '',
  needPay: false,
  payAmount: 0,
  remark: ''
})
// 添加支付金额显示和处理相关变量与方法
const payAmountDisplay = ref('')

// 重置表单数据函数
const resetForm = () => {
  formData.value = {
    rescueType: '',
    operatorId: '',
    needPay: false,
    payAmount: 0,
    remark: ''
  }
  payAmountDisplay.value = ''
}

// 监听抽屉显示状态，打开时重置表单
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    resetForm()
  }
})

// 监听formData.payAmount变化，同步到显示值
watch(() => formData.value.payAmount, (val) => {
  if (val !== undefined) {
    payAmountDisplay.value = (val / 100).toFixed(2)
  }
}, { immediate: true})

// 处理支付金额输入
const handlePayAmountInput = (value: string) => {
  // 清除非数字和非小数点字符
  let cleaned = value.replace(/[^\d.]/g, '')
  // 确保只有一个小数点
  cleaned = cleaned.replace(/(\.\d*)\./g, '$1')
  // 限制小数点后两位
  cleaned = cleaned.replace(/(\.\d{2}).*/g, '$1')
  // 处理前导零
  cleaned = cleaned.replace(/^0+(\d)/, '$1')
  // 处理只有小数点的情况
  if (cleaned === '.') cleaned = ''
  
  payAmountDisplay.value = cleaned
  
  // 转换为分单位存储
  const num = parseFloat(cleaned) || 0
  // 使用防抖延迟更新payAmount
  updatePayAmount(num)
}

// 防抖函数 - 延迟更新payAmount
const updatePayAmount = debounce((num: number) => {
  formData.value.payAmount = Math.round(num * 100)
}, 1000)

// 组件卸载时清除防抖
onUnmounted(() => {
  updatePayAmount.cancel()
})

const handleSubmit = async () => {
  try {
    // 验证支付金额
    if (formData.value.needPay && formData.value.payAmount <= 0) {
      ElMessage.error(t('Error.errAmountInvalid'))
      return
    }
    
    await AddRescueConfig(formData.value)
    ElMessage.success(t('Base.createSuccess'))
    resetForm() // 提交成功后重置表单
    emit('success')
    visible.value = false
  } catch (error) {
    console.error(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    title: _ctx.$t('Base.create'),
    direction: "rtl",
    size: "50%"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: formData.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Operation.rescueType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.rescueType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.rescueType) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rescueType).filter(item => item.value !== 0), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Operation.operatorName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: formData.value.operatorId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.operatorId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Operation.needPay')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.needPay,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.needPay) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.$t('Base.yes'),
                            value: true
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.$t('Base.no'),
                            value: false
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              (formData.value.needPay)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('Operation.payAmount')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: payAmountDisplay.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payAmountDisplay).value = $event)),
                            type: "text",
                            onInput: handlePayAmountInput
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('Base.remark')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.remark,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.remark) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.save')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})